<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">Enroll in PSP</h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request" id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar  [step]="16" [totalSteps]="19"></app-complete-bar >
               <h2 [innerHTML]="'DISCLOSURE_1' | translator:'base'">DISCLOSURE AND AUTHORIZATION</h2>
               <hr>
               <p [innerHTML]="'DISCLOSURE_2' | translator:'base'">
                 PSP is subject to the Fair Credit Reporting Act, Privacy Act, and any other applicable Federal laws.
                 <strong>Prior to requesting a driver's PSP record, a company must disclose to the driver the intent to request the driver's PSP record and obtain the driver's written authorization using the FMCSA mandated disclosure &amp; authorization form</strong>.
               </p>
               <p [innerHTML]="'DISCLOSURE_3' | translator:'base'">
                 Please download the required disclosure &amp; authorization form for your use when requesting PSP records:
               </p>
               <p class="text-center" [innerHTML]="localTranslation(generalService.getTranslation('DisclosureAndAuthDownload'))">
                 <a
                   href="##docBaseUrl##/PSPDisclosureandAuthorizationForm.pdf"
                   target="_blank"
                   class="btn btn-primary"
                   [title]="'DisclosureAndAuth' | translator:'base'"
                   name="Disclosure-And-Authorization-Form"
                   id="Disclosure-And-Authorization-Form"
                   tabindex="0"
                 >Disclosure &amp; Authorization Form <i class="fas fa-download" title="download" aria-hidden="true"></i></a>
               </p>
               <ul>
                 <li [innerHTML]="'DISCLOSURE_5' | translator:'base'">The disclosure &amp; authorization form must be a stand-alone document, and may NOT be altered or appear on the same page as any other documents.</li>
                 <li [innerHTML]="'DISCLOSURE_6' | translator:'base'">Both electronic and paper forms are acceptable.</li>
                 <li [innerHTML]="localTranslation(generalService.getTranslation('DISCLOSURE_7'))">
                    A <a
                      href="##docBaseUrl##/PSPDisclosureandAuthorizationForm.pdf"
                      target="_blank"
                      [title]="'DisclosureAndAuth' | translator:'base'"
                      name="Disclosure-And-Authorization-Form-PDF"
                      id="Disclosure-And-Authorization-Form-PDF"
                    >helpful PDF</a> offers additional information.
                 </li>
               </ul>
               <hr>
               <fieldset>
                 <div class="form-check">
                   <label class="form-check-label">
                      <input
                        id="agreeReadAgreement21"
                        class="form-check-input"
                        type="radio"
                        name="ReadAgreement"
                        [(ngModel)]="enrollmentService.newCustomer!.eulaAgreement!.readDisclosure"
                        value="agree"
                      >
                     <span [innerHTML]="'DISCLOSURE_8' | translator:'base'">I have read and agree to these disclosure and authorization requirements and am authorized to sign on behalf of the monthly account holder.</span>
                   </label>
                 </div>
                 <div class="form-check">
                   <label class="form-check-label">
                      <input
                        id="disagreeReadAgreement21"
                        class="form-check-input"
                        type="radio"
                        name="ReadAgreement"
                        value="---"
                        [(ngModel)]="enrollmentService.newCustomer!.eulaAgreement!.readDisclosure"
                      >
                     <span [innerHTML]="'DISCLOSURE_9' | translator:'base'">I disagree with these disclosure and authorization requirements.</span>
                   </label>
                 </div>
               </fieldset>
               <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                 <div class="btn-group" role="group">
                   <button routerLink="/signup/21" (click)="scrollToTop()" tag="button" [disabled]="!pageValid" class="btn btn-primary btn-strong" [title]="'DISCLOSURE_10' | translator:'base'" name="companyNext21" id="companyNext21">
                     <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'DISCLOSURE_10' | translator:'base'">Just One More Detail</span>
                   </button>
                 </div>
                 <div class="btn-group" role="group">
                   <button routerLink="/signup/19" tag="button" class="btn btn-outline-primary" (click)="scrollToTop()" [title]="'DISCLOSURE_11' | translator:'base'" name="companyBack21" id="companyBack21">
                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'DISCLOSURE_11' | translator:'base'">Certifications</span>
                   </button>
                   <a routerLink="/" tag="button" class="btn btn-light" (click)="scrollToTop()" name="companyCancel21" id="companyCancel21" [innerHTML]="'Cancel' | translator:'base'" [title]="'Cancel' | translator:'base'"></a>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="5"
         [pageType]="enrollmentService.newCustomer!.customerType || '-'"
         class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
       </div>
     </div>
   </div>
   
